import { render, staticRenderFns } from "./Vacancy.vue?vue&type=template&id=e06d5a5a&scoped=true"
import script from "./Vacancy.vue?vue&type=script&lang=js"
export * from "./Vacancy.vue?vue&type=script&lang=js"
import style0 from "./Vacancy.vue?vue&type=style&index=0&id=e06d5a5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06d5a5a",
  null
  
)

export default component.exports